<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->

      <!--Row-->
      <div class="row row-sm">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
          <div class="card">
            <div class="card-body pb-0 border-bottom">
              <div class="d-flex mb-3">
                <h6 class="card-title mb-0">All Assets</h6>
                <div class="ml-auto d-md-flex">
                  <div class="mr-2 mb-2">
                    <router-link to="/createasset"
                      ><button class="btn btn-primary btn-sm rounded-lg fs-13">
                        <i class="mdi mdi-plus-circle-outline"></i>Create New
                        Asset
                      </button></router-link
                    >
                  </div>

                  <div class="mr-2">
                    <router-link to="/bulkuploadassets"
                      ><button class="btn btn-primary btn-sm rounded-lg fs-13">
                        <i class="mdi mdi-plus-circle-outline"></i>Bulk Upload
                        Assets
                      </button></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="table-responsive">
                <table
                  id="example"
                  class="table table-striped"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>Asset Name</th>
                      <th>Days Of Service</th>
                      <th>Purchase Date</th>

                      <th>Tag Number</th>
                      <th>Purchase Amount</th>
                      <th>Edit</th>
                      <th>360 View</th>
                      <th>Renewal</th>
                      <th>Maintenance</th>
                      <th>Reallocation / Dispossal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="asset in assets" :key="asset.id">
                      <td>{{ asset.name }}</td>
                      <td>{{ asset.daysofService }}</td>
                      <td>{{ asset.purchaseDate.split("T")[0] }}</td>

                      <td>{{ asset.tagNumber }}</td>
                      <td>{{ asset.purchaseAmount }}</td>
                      <td>
                        <router-link
                          :to="{ name: 'Edit Asset', params: { id: asset.id } }"
                          ><button class="btn btn-primary">
                            Edit
                          </button></router-link
                        >
                      </td>

                      <td>
                        <router-link
                          :to="{
                            name: 'View Complete Asset Details',
                            params: { id: asset.id },
                          }"
                          ><button class="btn btn-primary">
                            360 View
                          </button></router-link
                        >
                      </td>

                      <td>
                        <router-link
                          :to="{
                            name: 'Create Renewal Schedule',
                            params: { id: asset.id },
                          }"
                          ><button class="btn btn-primary">
                            Schedule Renewal
                          </button></router-link
                        >
                      </td>

                      <td>
                        <router-link
                          :to="{
                            name: 'Schedule Maintenance',
                            params: { id: asset.id },
                          }"
                          ><button class="btn btn-primary">
                            Schedule Maintenance
                          </button></router-link
                        >
                      </td>

                      <td>
                        <router-link
                          :to="{
                            name: 'User Approval',
                            params: { id: asset.id },
                          }"
                          ><button class="btn btn-primary">
                            Set Up
                          </button></router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- COL END -->
      </div>
    </div>
    <!--Main Content Container-->
  </div>
  <!--Main Content-->
</template>

<script>
import $ from "jquery";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb,
  },
  props: ["user", "BaseURL"],
  data() {
    return {
      assets: [],
    };
  },

  methods: {},
  beforeCreate() {
    if (localStorage.getItem("role") !== "User") {
      window.location = "/error";
    }
  },

  mounted() {
    fetch(this.BaseURL + "/getAllAsset", {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.assets = data;

        $(() => {
          $("#example").DataTable();
        });
      });
  },
};
</script>